/* global jQuery */
( function ( $ ) {
	// responsive iframe backup strategy. check _media.scss p iframe
	$( 'p:has( iframe )' ).css( {
		position: 'relative',
		'padding-bottom': '56.25%',
		height: '0',
		overflow: 'hidden',
	} );

     // Selects the h1 element inside the #page-hero element
    $('#page-hero h1').each(function() {
        var $title = $(this);
        var html = $title.text();
        var firstWord = html.split(' ')[0]; // Gets the first word
        var rest = html.substring(firstWord.length); // Gets the rest of the title

        $title.html('<span class="fw-bold">' + firstWord + '</span>' + rest);
    });

    // Selects the h1 element inside the #post-hero element
    $('#post-title h1').each(function() {
        var $title = $(this);
        var words = $title.text().split(' '); // Splits all words into an array
        var firstWords; // Variable to hold the first word or first three words
        var rest; // Variable to hold the rest of the text
    
        if (words.length >= 3) {
            // If there are at least three words
            firstWords = words.slice(0, 3).join(' '); // Join the first three words
            rest = words.slice(3).join(' '); // The rest of the words
        } else {
            // If there are less than three words
            firstWords = words[0]; // Only the first word
            rest = words.slice(1).join(' '); // The rest starts from the second word
        }
    
        // Set the HTML of the title with the first words wrapped in a span
        $title.html('<span class="fw-bold">' + firstWords + '</span> ' + rest);
    });
    
} )( jQuery );

window.cookieconsent.initialise({
    container: document.getElementById("cookieconsent"),
    palette:{
     popup: {background: "#D29B90"},
     button: {background: "#EEEEEE"},
    },
    revokable: true,
    onStatusChange: function(status) {
     console.log(this.hasConsented() ?
      'enable cookies' : 'disable cookies');
    },
    "position": "bottom",
    "theme": "edgeless",
    "secure": true,
    "content": {
      "header": 'Cookies used on the website!',
      "message": 'This site uses cookies. By continuing to browse the site, you are agreeing to our use of cookies.',
      "dismiss": 'Close This!',
      "allow": 'Allow cookies',
      "deny": 'Decline',
      "link": 'Learn more',
      "href": '/privacy-policy',
      "close": '&#x274c;',
      "policy": 'Cookie Policy',
      "target": '_blank',
      }
   });

// ------------ swiper sliders -----------
( function ( $ ) {

    // Swiper - hero slider
    var heroSwiper = new Swiper(".header-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    speed: 1500,
    parallax: true,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    mousewheel: false,
    keyboard: true,
    autoplay: {
        delay: 6000,
    },
    loop: true,
    on: {
        init: function () {
            var swiper = this;
            for (var i = 0; i < swiper.slides.length; i++) {
                $(swiper.slides[i])
                    .find(".img")
                    .attr({
                        "data-swiper-parallax": 0.75 * swiper.width,
                    });
            }
        },
        resize: function () {
            this.update();
        },
    },
    });

    // Swiper - project gallery
    var projectSwiper = new Swiper('.project-gallery', {
        slidesPerView: 5.5,
        spaceBetween: 5,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2.5,
                spaceBetween: 5
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2.5,
                spaceBetween: 5
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 5.5,
                spaceBetween: 5
            }
          },
        speed: 1000,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.project-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.project-button-next',
          prevEl: '.project-button-prev',
        },
        autoplay: {
            delay: 2000,
        },
      });
      
      var testimonialSwiper = new Swiper('.testimonialSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        
        navigation: {
            nextEl: '.testimonial-button-next',
            prevEl: '.testimonial-button-prev',
        },
    });

    var dealerSwiper = new Swiper('.dealerSwiper', {
        slidesPerView: 8,
        spaceBetween: 30,
        loop: true,
        
        speed: 4000,
        loop: true,
        pagination: {
          el: '.dealer-pagination',
          clickable: true,
        },
        autoplay: {
            delay: 2000,
        },
    });

}) ( jQuery );


document.addEventListener("DOMContentLoaded", function() {
    var navbar = document.getElementById("menu");
    var stickyOffset = navbar.offsetTop + 300; // Adjust this offset as needed

    function adjustNavbarPosition() {
        if (window.pageYOffset > stickyOffset) {
            if (!navbar.classList.contains("sticky")) {
                navbar.classList.add("pre-sticky");
                setTimeout(function() {
                    navbar.classList.add("sticky");
                    navbar.classList.remove("pre-sticky");
                }, 10); // Short delay to start the slide-down transition
            }
        } else {
            navbar.classList.remove("sticky", "pre-sticky");
            navbar.style.top = ''; // Remove inline styles if any
        }
    }

    window.addEventListener('scroll', adjustNavbarPosition);
});


Fancybox.bind('[data-fancybox]', {
    Carousel: {
            transition: "slide",
          },
          // Disable image zoom animation on opening and closing
          Images: {
            zoom: false,
          },
          // Custom CSS transition on opening
            showClass: "f-fadeIn",

});



document.querySelectorAll('[id^="productCarousel-"]').forEach(carouselElement => {
    new Carousel(carouselElement, {
        transition: 'crossfade',
        preload: 3,
        Dots: false,
    });
});

